import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Trash2, Loader2 } from "lucide-react";
import { DeleteConfirmData } from "./types";

interface DeleteConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  deleteConfirmData: DeleteConfirmData | null;
  onConfirm: () => void;
  onCancel: () => void;
  isDeleting: boolean;
}

export default function DeleteConfirmDialog({
  open,
  onOpenChange,
  deleteConfirmData,
  onConfirm,
  onCancel,
  isDeleting
}: DeleteConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Trash2 className="h-5 w-5 text-red-500" />
            Confirm Deletion
          </DialogTitle>
        </DialogHeader>
        {deleteConfirmData && (
          <div className="space-y-4">
            <p className="text-sm text-neutral-600">
              Are you sure you want to delete this {deleteConfirmData.type}?
            </p>
            <div className="bg-neutral-50 dark:bg-neutral-800 p-3 rounded-lg">
              <p className="font-medium text-neutral-900 dark:text-neutral-100">
                {deleteConfirmData.name}
              </p>
            </div>
            <p className="text-xs text-red-600">
              This action cannot be undone.
            </p>
          </div>
        )}
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Deleting...
              </>
            ) : (
              <>
                <Trash2 className="mr-2 h-4 w-4" />
                Delete {deleteConfirmData?.type}
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
